import {Component, forwardRef, Input, OnInit, ViewEncapsulation} from '@angular/core';
import {ControlValueAccessor, FormControl, NG_VALUE_ACCESSOR} from '@angular/forms';
import * as moment from 'moment';

@Component({
  selector: 'app-form-radio-buttons',
  templateUrl: './form-radio-buttons.component.html',
  styleUrls: ['./form-radio-buttons.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => FormRadioButtonsComponent),
      multi: true
    }
  ]
})
export class FormRadioButtonsComponent implements OnInit, ControlValueAccessor {
  @Input() allowEmpty: boolean;
  @Input() field: string;
  @Input() formControl: FormControl;
  @Input() optionLabel: string;
  @Input() options: any[]; // {id, value} by default
  @Input() optionValue: string;

  public id: string;

  public onChange = (_: any) => {
  }
  public onTouch = () => {
  }

  constructor() {
  }

  // function to catch input changes and update form in parent
  public onInput($event: any): void {
    this.onTouch();
    this.onChange($event.value);
  }

  ngOnInit(): void {
    this.id = `${this.field}-${moment().unix()}`;
    if (!this.optionLabel) {
      this.optionLabel = 'id';
    }
    if (!this.optionValue) {
      this.optionValue = 'value';
    }
  }

  // value accessor functions
  writeValue(value: any): void {
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouch = fn;
  }
}
